import React from 'react'
import styles from './LogoGrid.module.css'

const LogoGrid = props => {
  const listItems = props.items.map(item => (
    <li key={item.node.id}>
      <img src={item.node.childMarkdownRemark.frontmatter.logo} />
    </li>
  ))

  return (
    <div id="partners" className={styles.wrapper}>
      <ul className={styles.logoList}>{listItems}</ul>
    </div>
  )
}

export default LogoGrid



// WEBPACK FOOTER //
// ./src/components/LogoGrid/LogoGrid.js